var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.024 20.048C4.50352 20.048 0 15.5445 0 10.024C0 4.50353 4.50352 0 10.024 0C12.4937 0 14.915 0.920072 16.7552 2.56653C16.9004 2.66338 16.9004 2.85708 16.7552 3.00235C16.6583 3.14763 16.4645 3.14763 16.3193 3.00235C14.5759 1.45275 12.3484 0.581093 10.024 0.581093C4.84249 0.581093 0.629551 4.79409 0.629551 9.97559C0.629551 15.1571 4.84249 19.3701 10.024 19.3701C15.2055 19.3701 19.4185 15.1571 19.4185 9.97559C19.4185 9.78188 19.5637 9.68503 19.709 9.68503C19.9027 9.68503 19.9996 9.83031 19.9996 9.97559C20.048 15.5445 15.5445 20.048 10.024 20.048Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6075 10.3145H10.024C9.83027 10.3145 9.73349 10.1692 9.73349 10.0239V3.09915C9.73349 2.90545 9.87869 2.80859 10.024 2.80859C10.1692 2.80859 10.3146 2.95387 10.3146 3.09915V9.7334H13.6075C13.8012 9.7334 13.898 9.87866 13.898 10.0239C13.9464 10.1692 13.8012 10.3145 13.6075 10.3145Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1401 3.38992C13.9948 3.38992 13.8496 3.29306 13.8496 3.09936C13.8496 2.90566 13.9464 2.76038 14.1401 2.76038L16.2709 2.51826L16.0288 0.387551C16.0288 0.193851 16.1256 0.048584 16.3193 0.048584C16.513 0.048584 16.6582 0.145422 16.6582 0.339123L16.9003 2.80881C16.9003 3.00251 16.8036 3.14779 16.6099 3.14779L14.1401 3.38992Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.fb365124fc477903fe69377ff1e4848d.svg";
export { ForwardRef as ReactComponent };